/* eslint-disable complexity */
/* eslint-disable @typescript-eslint/no-explicit-any */
import axios from "axios";
import auth0 from "@/auth";
import { useMockAuth } from "@/modules/authWrapper";
import { isPlatform } from "@ionic/vue";
import { Browser } from "@capacitor/browser";
import { openReplayTracker } from "@/main";
import { WebAnalytics } from "@/modules/webAnalytics";
import { env } from "@/env";
import posthog from "posthog-js";

const isCypressTest = !!localStorage.getItem("auth0Cypress");
const { getAccessTokenSilently, loginWithRedirect } = isCypressTest ? useMockAuth() : auth0;

export const apiClient = axios.create({
	baseURL: env.API_BASE + "/backstage",
	headers: {
		Accept: "application/json",
		"Content-Type": "application/json",
	},
});

apiClient.interceptors.request.use(
	async (config) => {
		try {
			const tokenResponse = await getAccessTokenSilently();

			if (config.headers) {
				config.headers["Authorization"] = `Bearer ${tokenResponse}`;
				if (openReplayTracker.isActive()) {
					config.headers["X-OpenReplay"] =
						openReplayTracker.getSessionURL({ withCurrentTime: true }) || `https://app.openreplay.com/${env.OPENREPLAY_PROJECTID}/session/${openReplayTracker.getSessionID()}`;
				}

				if (posthog.is_capturing()) {
					config.headers["X-PostHog-Session-ID"] = posthog.get_session_id();
					config.headers["X-PostHog-Distinct-ID"] = posthog.get_distinct_id();
					config.headers["X-PostHog-Session-Replay"] = posthog.get_session_replay_url({
						withTimestamp: true,
					});
				}
			}
			return config;
		} catch (err: any) {
			console.log("[SH] Authentication Interceptor Error", err);
			WebAnalytics.trackFlexible("Application Error", {
				message: "Authentication Interceptor Error",
				errorString: JSON.stringify(err),
				errorMessage: err.error ? err.error : "No error message",
			});
			if (err && err.error) {
				console.log("[SH] Auth Error", err.error, err);
			}
			if (err.error === "missing_refresh_token" || err.error === "invalid_grant") {
				if (isPlatform("capacitor")) {
					await loginWithRedirect({
						async openUrl(url) {
							await Browser.open({ url });
						},
					});
				} else {
					await loginWithRedirect();
				}
			}
			if (err.error !== "login_required") {
				return Promise.reject(err);
			} else {
				if (isPlatform("capacitor")) {
					await loginWithRedirect({
						async openUrl(url) {
							await Browser.open({ url });
						},
					});
				} else {
					await loginWithRedirect();
				}
			}
		}
	},
	(error) => {
		return Promise.reject(error);
	}
);

apiClient.interceptors.response.use(
	(response) => response,
	async (error) => {
		if (error.response?.data.error) {
			if (error.response?.status >= 500) {
				WebAnalytics.trackFlexible("Server Exception", error.response?.data || {});
			} else if (error.response?.status >= 400) {
				WebAnalytics.trackFlexible("Business Exception", error.response?.data || {});
			}
		}
		return Promise.reject(error);
	}
);
